<template>
	<div class="tpl my-question-wrap">
		<mt-header title="我的想问" fixed>
			<router-link :to="{name:'mine'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
		</mt-header>
		<div class="banner">
			<img src="../../assets/img/mine/center_problem_banner.png" alt="" />
		</div>
		<p class="page-title">想问的问题<span>(最多设置三个哦)</span></p>
		<div class="add-question" v-if="qList.length<3">
			<button @click="addQuestion">+点击添加问题</button>
		</div>
		<div class="question-list">
			<ul>
				<li v-for="item in qList">
					<div class="question-title">
						<span class="item-text">
							<img src="../../assets/img/mine/center_problem_ic_list_selected.png" alt="" />
							{{item.problem}}
						</span>
						<span class="item-option" @click="showOptions(item.p_id,item.problem,item.answer)"><img src="../../assets/img/mine/center_problem_more_pressed.png"/></span>
					</div>
					<div class="question-answer" v-if="item.answer!=''">
						<span>我的回答：</span>
						{{item.answer}}
					</div>
					<div class="add-question" v-else>
						<button @click="addAnswer(item.p_id,item.problem)">+点击添加我的回答</button>
					</div>
				</li>
			</ul>
		</div>
		<mend-question :uid="uid" :qid="optionId" :title="optionTitle" :text="optionQuestion" v-if="showAddQuestion" @closeMend="closeMend" @refreshData="getQuestionList"></mend-question>
		<mend-answer :uid="uid" :qid="optionId" :title="optionTitle" :text="optionAnswer" v-if="showAddAnswer" @closeMend="closeMend"></mend-answer>
		<mt-actionsheet
		  :actions="actions"
		  v-model="sheetVisible">
		</mt-actionsheet>
	</div>
</template>

<script>
	import MendQuestion from "./MendQuestion"
	import MendAnswer from "./MendAnswer"
	export default{
		name:"my-question",
		components:{
			MendQuestion,
			MendAnswer,
		},
		data(){
			return{
				uid:"",
				qList:"",
				optionId:"",
				optionTitle:"",
				optionQuestion:"",
				optionAnswer:"",
				sheetVisible:false,
				actions:[
					{name:"修改问题",method:this.mendQuestion},
					{name:"修改回答",method:this.mendAnswer},
					{name:"删除问题",method:this.delQuestion}
				],
				showAddQuestion:0,
				showAddAnswer:0,
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			
			this.getQuestionList()
		},
		methods:{
			getQuestionList(){
				this.$axios({
					url:"My/ProblemList",
					method:"post",
					data:{
						uid:this.uid
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.qList = res.data.data;
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			showOptions(id,p,a){
				console.log(id);
				this.optionId = id;
				this.optionQuestion = p;
				this.optionAnswer = a;
				this.sheetVisible = true;
			},
			addQuestion(){
				this.optionId = "";
				this.optionQuestion = "";
				this.optionAnswer = "";
				this.optionTitle="添加问题";
				this.showAddQuestion = 1;
			},
			mendQuestion(){
				console.log("修改问题",this.optionId,this.optionQuestion,this.optionAnswer);
				this.optionTitle="修改问题";
				this.showAddQuestion = 1;
			},
			closeMend(s){
				
				if(s==0){
					this.showAddQuestion = 0;
					this.showAddAnswer = 0;
				}else{
					this.showAddQuestion = 0;
					this.showAddAnswer = 0;
					this.getQuestionList();
				}
				
			},
			addAnswer(pid,p){
				this.optionId = pid;
				this.optionQuestion = p;
				this.optionAnswer = "";
				this.optionTitle="添加回答";
				this.showAddAnswer = 1;
			},
			mendAnswer(){
				console.log("修改回答"+this.optionId);
				this.optionTitle="修改回答";
				this.showAddAnswer = 1;
			},
			delQuestion(){
				console.log("删除问题"+this.optionId);
				this.$messagebox.confirm('确定删除这条问题吗?',"").then(action => {
					this.$axios({
						url:"My/DelProblem",
						method:"post",
						data:{
							uid:this.uid,
							p_id:this.optionId
						}
					}).then(res=>{
						console.log(res);
						this.$toast({message: res.data.msg,position: "bottom",duration: 3000});
					}).catch(err=>{
						console.log(err);
						this.$toast({message: "操作失败",position: "bottom",duration: 3000});						
					})
				});
			}
		}
	}
</script>

<style scoped>
	.my-question-wrap{
		padding-top: 2.5rem;
		padding-bottom: 1rem;
	}
	.banner img{
		width: 100%;
		display: block;
	}
	.page-title{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		line-height: 1.8rem;
		padding: 0.5rem 1rem;
		background: #fff;
	}
	.page-title span{
		font-size: 0.8rem;
		color: #7b7b7b;
		font-weight: normal;
		margin-left: 0.5rem;
	}
	.add-question{
		padding: 0.5rem 1.5rem;
	}
	.add-question button{
		width: 100%;
		height: 2.5rem;
		text-align: center;
		background: #fff;
		border: 1px solid #eee;
		outline: 0;
		font-size: 0.8rem;
		color: #7b7b7b;
		border-radius: 5px;
	}
	.question-list .question-title{
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #fff;
		padding: 0.4rem 1rem;
		margin-top: 0.2rem;
	}
	.question-list .question-title .item-text{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 0.8rem;
		color: #875bf0;
	}
	.question-list .question-title .item-option{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.question-list .question-title .item-option:active{
		opacity: 0.8;
	}
	.question-list .question-title img{
		width: 1.5rem;
		margin-right: 0.3rem;
	}
	.question-list .question-answer{
		padding: 1rem;
		background: #fff;
		border-top: 1px solid #f3f3f3;
		font-size: 0.8rem;
		color: #7B7B7B;
		line-height: 1.3rem;
	}
	.question-list .question-answer span{
		color: #282828;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/MyQuestion.vue